import {variants as TableVariants} from './Table.styles';
import {baseStyles as ButtonBaseStyles} from './Button.styles';
import {baseStyles as TabsBaseStyles} from './Tabs.styles';
import drawerStyles from 'common/theme/Drawer.styles';

const theme = {
    breakpoints: {
        navigation: '75rem', // 1200px
    },
    colors: {
        navBlue: '#e9f0f9',
    },
    space: {
        4.5: '1.125rem',
        8.5: '2.125rem',
    },
    sizes: {
        4.5: '1.125rem',
        8.5: '2.125rem',
    },
    components: {
        Button: {
            baseStyle: ButtonBaseStyles,
        },
        Drawer: drawerStyles,
        Table: {
            variants: TableVariants,
        },
        Tabs: {
            baseStyle: TabsBaseStyles,
        },
    },
    fonts: {
        body: `"Plus Jakarta Sans Variable", sans-serif`,
        heading: `"Plus Jakarta Sans Variable", sans-serif`,
    },
};

export default theme;
